// extracted by mini-css-extract-plugin
module.exports = {"buoyMapMarker":"BuoyMapMarker_buoyMapMarker__H1itd","buoyMapMarkerActive":"BuoyMapMarker_buoyMapMarkerActive___j6v3","click-ripple":"BuoyMapMarker_click-ripple__vU2Ae"};